import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';
import './IpPhone.css';
import CopywritingPhone from './CopywritingPhone';
import PortabilidadeSection from '../PortabilidadeSection/PortabilidadeSection';

const IpPhone = () => {
  const [cards, setCards] = useState([]);

  const TextRender = ({ htmlContent }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  };

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/cardPhones`);
        setCards(response.data);
      } catch (error) {
        console.error('Erro ao buscar os cards:', error);
      }
    };

    fetchCards();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <div className="ipphone-service-title mb-4">              
              <CopywritingPhone />
            </div>
          </Col>
        </Row>
      </Container>
      <PortabilidadeSection />
    </>
  );
};

export default IpPhone;
